import { render, staticRenderFns } from "./RenewPwdPage.vue?vue&type=template&id=0551f66e&scoped=true&"
import script from "./RenewPwdPage.vue?vue&type=script&lang=ts&"
export * from "./RenewPwdPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0551f66e",
  null
  
)

export default component.exports